import * as React from 'react';
import styled from '@emotion/styled';
import { HomeNewsSection } from './HomeNewsSection';
import { HomeDocsSection } from './HomeDocsSection';
import { HomeRoadmapSection } from './HomeRoadmapSection';

export const HomeUpdatesWidget: React.FC = () => (
  <S.Root>
    <HomeNewsSection />
    <HomeDocsSection />
    <HomeRoadmapSection />
  </S.Root>
);

namespace S {
  export const Root = styled.div`
    display: grid;
    gap: 48px;
    margin-top: 70px;
  `;
}
